/* eslint-disable no-unused-vars */
import Phaser from 'phaser';

class Item {
  constructor(scene, id) {
    this.scene = scene;
    this.id = id;
    this.container = null;
    this.cursorManager = this.scene.cursorManager;
  }

  create() {
    this.container = this.scene.add.container(0, 0);
    this.createItems();
    this.makeInteractive();
    this.makeDraggable();
    this.cursorManager.setDefaultDraggableEvents(this.container);

    return this;
  }

  setDragCallbacks(startDragCallback, stopDragCallback) {
    if (startDragCallback) {
      this.container.on('dragstart', startDragCallback);
    }

    if (stopDragCallback) {
      this.container.on('dragend', stopDragCallback);
    }
  }

  makeInteractive() {
    const bounds = this.container.getBounds();
    this.container.setInteractive({
      hitArea: new Phaser.Geom.Rectangle(0, 0, bounds.width, bounds.height),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
      // cursor: "url(../phaser-assets/cursors/cursor_mouseover_32.png), pointer"
    });
  }

  makeDraggable(isDraggable = true) {
    if (isDraggable) {
      this.scene.input.setDraggable(this.container);

      this.container.on(
        'drag',
        function (obj, pointer, x, y) {
          obj.setPosition(pointer.x - this.getWidth() / 2, pointer.y - this.getHeight() / 2);
        }.bind(this, this.container),
      );
    } else {
      this.scene.input.setDraggable(this.container, false);
    }
  }

  createItems() {
    let commonWidth = 0;
    const sprite = this.scene.add.sprite(commonWidth, 0, `asset-${this.id}`).setOrigin(0, 0);
    this.container.add(sprite);
    commonWidth += sprite.displayWidth;
    this.setData('width', this.getWidth());
  }

  getWidth() {
    const bounds = this.container.getBounds();
    return bounds.width;
  }

  getHeight() {
    const bounds = this.container.getBounds();
    return bounds.height;
  }

  setData(key, value) {
    this.container.setData(key, value);
  }

  getData(key) {
    return this.container.getData(key);
  }

  setScale(scale) {
    this.container.setScale(scale);
    this.setData('width', this.getWidth());
  }

  place(x, y) {
    this.container.setPosition(x, y);
  }

  getContainer() {
    return this.container;
  }

  destroyItem() {
    this.container.destroy();
  }
}
export default Item;
